import { render, staticRenderFns } from "./TagChip.vue?vue&type=template&id=4354b4c9"
import script from "./TagChip.vue?vue&type=script&lang=ts"
export * from "./TagChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports